import { useState } from 'react';
import { cn } from '@/lib/utils';

interface Props {
  value: number | null;
  disabled?: boolean;
  onSelect: (value: number) => void;
}

export function PulseButtonRow({ value, disabled, onSelect }: Props) {
  const [hover, setHover] = useState<number | null>(null);

  return (
    <div
      role="radiogroup"
      aria-label="How are you feeling about work today?"
      className="space-y-3"
    >
      <div className="grid grid-cols-5 gap-2 sm:grid-cols-10">
        {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => {
          const selected = value === n;
          return (
            <button
              key={n}
              type="button"
              role="radio"
              aria-checked={selected}
              disabled={disabled}
              onMouseEnter={() => setHover(n)}
              onMouseLeave={() => setHover(null)}
              onClick={() => onSelect(n)}
              className={cn(
                'aspect-square rounded-lg border text-lg font-medium transition-all',
                'focus:outline-none focus-visible:ring-2 focus-visible:ring-ring',
                selected
                  ? 'bg-primary text-primary-foreground border-primary shadow-sm'
                  : hover === n
                    ? 'bg-muted border-foreground/30'
                    : 'bg-background border-border hover:border-foreground/30',
                disabled && 'opacity-60 cursor-not-allowed',
              )}
            >
              {n}
            </button>
          );
        })}
      </div>
      <div className="flex items-start justify-between gap-3 text-xs text-muted-foreground">
        <div className="flex flex-col items-start max-w-[45%]">
          <span className="font-semibold text-foreground">1 — Worst</span>
          <span>The lowest you've ever felt about work.</span>
        </div>
        <div className="flex-1 mt-2 h-px bg-gradient-to-r from-destructive/40 via-muted-foreground/30 to-primary/60" />
        <div className="flex flex-col items-end text-right max-w-[45%]">
          <span className="font-semibold text-foreground">10 — Best</span>
          <span>The best you've ever felt about work.</span>
        </div>
      </div>
    </div>
  );
}
